export default "__VITE_ASSET__YJF_NB92__"